<div class="card">
  <div class="card-body text-center">
    <div class="align-center">
      <a href="/login" routerLink="/login">
        <img src="assets/images/logo-skuba.png" alt="{{'SKUBA_LOGO'| translate}}" class="home-logo form-logo">
      </a>
    </div>
    <h2>{{'FORGOT_USERNAME_Q' | translate}}</h2>
    <p class="fp-description">{{'FORGOT_USERNAME_DESCRIPTION' | translate}}</p>
    <form class="forgot-user-form"
          (ngSubmit)="submit()"
          [formGroup]="forgotUserForm"
          novalidate
          #formDir="ngForm">
      <app-input
        formControlName="email"
        placeholder="EMAIL"
        label="EMAIL"
        [focus]="true">
        <app-input-validation
          className="error"
          message="REQUIRED"
          [condition]="(forgotUserForm.get('email').touched || formDir.submitted) && forgotUserForm.get('email').hasError('required')">
        </app-input-validation>
        <app-input-validation
          className="error"
          message="EMAIL_VALIDATION_ERROR"
          [condition]="(forgotUserForm.get('email').touched || formDir.submitted) && forgotUserForm.get('email').hasError('email')">
        </app-input-validation>
      </app-input>
      <div class="form-group align-center">
        <app-button [className]="'btn-red'" text="CONFIRM"></app-button>
      </div>
    </form>
  </div>
</div>
